module.exports = __webpack_public_path__ + "static/media/thumbnail.78659cd9.jpg";